import { STATUS } from "@/constants/statuses";
import {
    EntityState,
    EntityStore,
    StoreConfig,
    arrayAdd,
    arrayRemove,
    arrayUpdate,
} from "@datorama/akita";
import { injectable } from "tsyringe";

import ProductEntity from "../entities/ProductEntity";

const IN_QUEUE_STATUS = "IN_QUEUE";

type StatusItemKey = {
    productId: number;
    status: STATUS.LOADING | STATUS.READY | typeof IN_QUEUE_STATUS;
};

export interface ProductsState extends EntityState<ProductEntity, number> {
    productStatuses: StatusItemKey[];
}

export function createInitialState(): ProductsState {
    return {
        productStatuses: [],
    };
}

@injectable()
@StoreConfig({ name: "ProductsStore" })
export class ProductsStore extends EntityStore<ProductsState> {
    constructor() {
        super(createInitialState());
    }

    public addProductInQueue(productId: number) {
        this.update(({ productStatuses }) => {
            if (
                !productStatuses.find(
                    (statusItem) => statusItem.productId === productId
                )
            ) {
                return {
                    productStatuses: arrayAdd(productStatuses, {
                        productId,
                        status: IN_QUEUE_STATUS,
                    }),
                };
            }
        });
    }

    public deleteProductStatus(productId: number) {
        this.update(({ productStatuses }) => ({
            productStatuses: arrayRemove(
                productStatuses,
                ({ productId: _productId }) => _productId === productId
            ),
        }));
    }

    public setLoadingStatus(productId: number) {
        this.update(({ productStatuses }) => ({
            productStatuses: arrayUpdate(
                productStatuses,
                ({ productId: _productId }) => _productId === productId,
                { status: STATUS.LOADING } as StatusItemKey
            ),
        }));
    }

    public setReadyStatus(productId: number) {
        this.update(({ productStatuses }) => ({
            productStatuses: arrayUpdate(
                productStatuses,
                ({ productId: _productId }) => _productId === productId,
                { status: STATUS.READY } as StatusItemKey
            ),
        }));
    }
}
